import { Button } from '@/components/common/Button';
import { DrawerClose } from '@/components/common/Drawer';
import { HeaderDrawer } from '@/components/layout/HeaderDrawer';
import { HeaderWrapper } from '@/components/layout/HeaderWrapper';
import { routes } from '@/routes/routes';
import { Link } from '@tanstack/react-router';

export const HomeHeader = () => {
  return (
    <HeaderWrapper
      desktopContent={
        <div className="flex gap-2.5">
          <Button variant="outlinePrimary" asChild>
            <Link to={routes.auth.login} search={{ type: 'doctor' }}>
              Doctor login
            </Link>
          </Button>
          <Button variant="secondary" asChild>
            <Link to={routes.auth.login} search={{ type: 'pacient' }}>
              Patient login
            </Link>
          </Button>
        </div>
      }
      mobileContent={
        <HeaderDrawer>
          <DrawerClose asChild>
            <Button variant="outlinePrimary" asChild>
              <Link to={routes.auth.login} search={{ type: 'doctor' }}>
                Doctor login
              </Link>
            </Button>
          </DrawerClose>
          <DrawerClose asChild>
            <Button variant="secondary" asChild>
              <Link to={routes.auth.login} search={{ type: 'pacient' }}>
                Patient login
              </Link>
            </Button>
          </DrawerClose>
        </HeaderDrawer>
      }
    />
  );
};
